import { HARVEST_ERROR_CODES } from "../types/Admin";
var KNOWN_CODES = new Set(HARVEST_ERROR_CODES);
var REASON_ID_PREFIX = "ui-br-legaldeposits.harvest.reason.";
export var formatHarvestTime = function (intl, instant) {
    if (!instant) {
        return null;
    }
    var date = new Date(instant);
    if (Number.isNaN(date.getTime())) {
        return null;
    }
    return intl.formatDate(date, {
        day: "numeric",
        month: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
    });
};
export var formatHarvestReason = function (intl, _a) {
    var errorCode = _a.errorCode, errorMessage = _a.errorMessage, lastSignOfLifeAt = _a.lastSignOfLifeAt;
    var message = errorMessage || null;
    if (!errorCode) {
        return message;
    }
    if (!KNOWN_CODES.has(errorCode)) {
        return message !== null && message !== void 0 ? message : errorCode;
    }
    var time = formatHarvestTime(intl, lastSignOfLifeAt);
    var id = errorCode === "RUN_WENT_SILENT" && time === null
        ? "".concat(REASON_ID_PREFIX, "RUN_WENT_SILENT_NO_TIME")
        : "".concat(REASON_ID_PREFIX).concat(errorCode);
    return intl.formatMessage({ id: id }, { time: time, detail: message !== null && message !== void 0 ? message : "" });
};
